import React, { useState } from "react";
// UI Framework
import { Menu, MenuItem, Tooltip } from "@mui/material";
// Common Components
import Button from "src/Components/Button";
import DatePicker from "src/Components/DatePicker";
import FullScreenLoading from "src/Components/Loading/FullScreenLoading";
import { TimePicker, Modal, WrappedTimeSeriesChart } from "src/Components";
import Cell from "src/Tables/TableTemplate//Cell";
// Requests
import { instrumentBubbleCurrentGraph } from "src/Requests/goldArbitrage";
// Utilities
import { packetErrorHandler } from "src/Utils/requestUtils";
import moment from "moment";
// Types
import { Graph_Dto } from "src/Interfaces/orderbookGraphInterfaces";
import { IInstrumentBubbleCurrentGraph } from "src/Interfaces/goldArbitrage";

const ChartSearchParamUI = ({ row }: any) => {
  // local store
  const [loading, setLoading] = React.useState(false);
  const [graphData, setGraphData] = React.useState<Graph_Dto[]>([]);
  const [formValues, setFormValues] =
    React.useState<IInstrumentBubbleCurrentGraph>({
      date: moment().format("YYYY-MM-DD"),
      fromTime: "11:00:00",
      toTime: "18:00:00",
      ins2: row.destIns,
      ins1: row.srcIns,
    });

  const [timeISOValues, setTimeISOValues] = React.useState<{
    fromTime: string | null;
    toTime: string | null;
  }>({
    fromTime: getFromTimeISODefaultValue(),
    toTime: getToTimeISODefaultValue(),
  });

  function getFromTimeISODefaultValue() {
    const defaultFromTime = new Date();
    defaultFromTime.setHours(11, 0, 0, 0); // Set to 11:00 AM today

    return defaultFromTime.toISOString();
  }
  function getToTimeISODefaultValue() {
    const defaultToTime = new Date();
    defaultToTime.setHours(18, 0, 0, 0); // Set to 18:00 PM today
    return defaultToTime.toISOString();
  }

  const changeHandler = (name: string, value: any) => {
    setFormValues({ ...formValues, [name]: value });
  };

  const timePickerChangeHandler = (
    name: string,
    value: {
      timeString: string;
      ISOString: string | null;
    },
  ) => {
    setTimeISOValues({ ...timeISOValues, [name]: value.ISOString });
    setFormValues({ ...formValues, [name]: value.timeString });
  };

  React.useEffect(() => {
    setLoading(true);
    const data: IInstrumentBubbleCurrentGraph = {
      fromTime: formValues.fromTime,
      toTime: formValues.toTime,
      ins1: row.srcIns || row.req.srcIns,
      ins2: row.destIns || row.req.destIns,
      date: formValues.date,
    };

    instrumentBubbleCurrentGraph(data)
      .then((resp: Graph_Dto | Graph_Dto[]) => {
        setGraphData(Array.isArray(resp) ? resp : resp ? [resp] : []);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  }, []);
  const onSubmit = () => {
    setLoading(true);
    const data: IInstrumentBubbleCurrentGraph = {
      fromTime: formValues.fromTime,
      toTime: formValues.toTime,
      ins1: row.req.srcIns,
      ins2: row.req.destIns,
      date: formValues.date,
    };

    instrumentBubbleCurrentGraph(data)
      .then((resp: Graph_Dto | Graph_Dto[]) => {
        setGraphData(Array.isArray(resp) ? resp : resp ? [resp] : []);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  const getChartUI = () => {
    return (
      <div className="chart-fill-modal">
        <div className="flex flex-row justify-center items-center gap-6 mx-auto">
          <div>مبدا: {row.srcInstrumentName}</div>
          <div>مقصد: {row.destInstrumentName}</div>
        </div>
        <WrappedTimeSeriesChart
          dataset={graphData}
          className="h-full w-full"
          hasSecondaryYAxis={false}
        />
      </div>
    );
  };

  return (
    <>
      <div className="h-full w-full min-h-0 flex flex-row items-stretch gap-5 px-4">
        {loading ? <FullScreenLoading /> : <></>}
        <div className="flex shrink-0 flex-col justify-start items-start gap-3">
          <DatePicker
            label="تاریخ"
            name="date"
            onChange={changeHandler}
            value={formValues.date}
          />
          <TimePicker
            name="fromTime"
            value={timeISOValues.fromTime}
            onChange={timePickerChangeHandler}
            placeholder="از ساعت"
          />
          <TimePicker
            name="toTime"
            value={timeISOValues.toTime}
            onChange={timePickerChangeHandler}
            placeholder="تا ساعت"
          />
          <Button text="جستجو" onClick={onSubmit} variant="contained" />
        </div>
        {getChartUI()}
      </div>
    </>
  );
};

export default ChartSearchParamUI;
